var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"table-page-header d-flex justify-space-between align-center"},[_c('div',{staticClass:"title font-weight-regular"},[_vm._v(_vm._s(_vm.title))]),_vm._t("header-actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }